import { initialState } from "./state"

export default {
  reset: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setRoute: (state, route) => {
    state.questions = route.questions
    delete route.questions
    state.route = route
  },
  setSellersOptions: (state, payload) => (state.sellersOptions = payload),
  setUsersOptions: (state, payload) => (state.usersOptions = payload)
}
